import { css } from 'emotion';

const referenceWrapperStyles = css`
	textarea {
		height: 48px;
		padding: 14px 12px;
	}
`;

export { referenceWrapperStyles };
